import { useSyncExternalStore } from "react";

/**
 * The top bar's center slot on landscape phones. Views portal their tool
 * row (AI layout / Measure / Tools, Start over / Add, …) into it so
 * nothing floats over the top of a short canvas. Null when the slot isn't
 * mounted (every other layout).
 */
let slot: HTMLElement | null = null;
const listeners = new Set<() => void>();

export function setTopbarSlot(el: HTMLElement | null) {
  if (el === slot) return;
  slot = el;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

const snapshot = () => slot;

export function useTopbarSlot(): HTMLElement | null {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
